import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import { getAdditionalLinkAttributes } from '@jelly/utils';

/**
 * AnchorTag - common component
 * It accepts:
 * - an href
 * - any other prop you want
 * Additionally, it features:
 * - a spread operator to handle onClick, className, style, etc
 **/
export function AnchorTag(_ref) {
  var children = _ref.children,
      href = _ref.href,
      additionalAttributes = _objectWithoutProperties(_ref, ["children", "href"]);

  return /*#__PURE__*/React.createElement("a", _extends({
    href: href
  }, additionalAttributes, getAdditionalLinkAttributes(href)), children);
}